module.exports = __webpack_public_path__ + "media/components/Application/Sponsors/Index/01-32ca5db8072dc5421f9e3c3632e7c766.png";